import { render } from "./ComponenteIdioma.vue?vue&type=template&id=597c09e4&scoped=true"
import script from "./ComponenteIdioma.vue?vue&type=script&lang=js"
export * from "./ComponenteIdioma.vue?vue&type=script&lang=js"

import "./ComponenteIdioma.vue?vue&type=style&index=0&id=597c09e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597c09e4"]])

export default __exports__